export default __webpack_public_path__ + "static/media/sideImage2.a5bfa92e.png";